module.exports = __webpack_public_path__ + "media/images/tarifario-edbb56915e8470bd943fb260b95ab430.png";